import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import axios from "axios";


const fetchData = async (endpoint, params) => {
  const { data } = await axios.get(
    `https://stage.myskool.club/myskoolcollabapibackend/api/${endpoint}`,
    { params: params }
  );
  return data;
};


export const useTestimonial = () => {
  return useQuery({
    queryKey: ["testimonial"],
    queryFn: () => fetchData("collab-testimonial"),
  });
};

export const useEvents = () => {
  return useInfiniteQuery({
    queryKey: ["events"],
    queryFn: async ({ pageParam = 1 }) => {
      const data = await fetchData(`collab-events?page=${pageParam}`);
      return data;
    },
    getNextPageParam: (lastPage) => {
      return lastPage.current_page < lastPage.last_page ? lastPage.current_page + 1 : undefined;
    }
  });
};

export const useCourses = () => {
  return useInfiniteQuery({
    queryKey: ["courses"],
    queryFn: async ({ pageParam = 1 }) => {
      const data = await fetchData(`collab-courses?page=${pageParam}`);
      data.data = data.data.sort((a, b) => b.is_featured - a.is_featured);
      return data;
    },
    getNextPageParam: (lastPage) => {
      return lastPage.current_page < lastPage.last_page ? lastPage.current_page + 1 : undefined;
    }
  });
};

export const useFooter = () => {
  return useQuery({
    queryKey: ["footer"],
    queryFn: () => fetchData("collab-site-footer"),
  });
};

export const useCourseDetail = (id) => {
  return useQuery({
    queryKey: ["coursedetail"],
    queryFn: async () => {
      const data = await fetchData(`collab-course-view/${id}`);
      data.related_courses = data.related_courses.sort((a, b) => b.is_featured - a.is_featured);
      return data;
    },
  });
}

export const useCourseFilter = (filters) => {
  return useQuery({
    queryKey: ["course-filter", filters],
    queryFn: async () => {
      const data = await fetchData("collab-course-filter", filters);
      data.data = data.data.sort((a, b) => b.is_featured - a.is_featured);
      return data
    },
    enabled: filters && Object.keys(filters).length > 0,
  });
};


export const useEventFilter = (filters) => {
  return useQuery({
    queryKey: ["event-filter", filters],
    queryFn: async () => {
      return await fetchData("collab-events-filter", filters);
    },
    enabled: filters && Object.keys(filters).length > 0,
  });
};

export const useLocationCourse = () => {
  return useQuery({
    queryKey: ["location"],
    queryFn: () => fetchData("collab-course-filter-location"),
  });
};

export const useCourseCategory = () => {
  return useQuery({
    queryKey: ["category"],
    queryFn: () => fetchData("collab-categories"),
  });
};

export const useFaq = () => {
  return useQuery({
    queryKey: ["faq"],
    queryFn: () => fetchData("collab-faq-details"),
  });
};


export const useEventDetail = (id) => {
  return useQuery({
    queryKey: ["eventdetail"],
    queryFn: async () => {
      const data = await fetchData(`collab-event-view/${id}`);
      return data;
    },
  });
}

export const useEventCategory = () => {
  return useQuery({
    queryKey: ["eventcategory"],
    queryFn: () => fetchData("collab-events-categories"),
  });
};

export const useVenueCityList = () => {
  return useQuery({
    queryKey: ["venuecitylist"],
    queryFn: () => fetchData("collab-events-venue-city-details"),
  });
};

export const useAboutUse = () => {
  return useQuery({
    queryKey: ["aboutus"],
    queryFn: () => fetchData("collab-about-us"),
  });
};